import { Routes, Route } from "react-router-dom";
import Tutorial from "@/pages/Tutorial";
import VerifierView from "@/components/common/Verifier";
import Explanation from "@/components/common/Explanation";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Tutorial />} />
      <Route path="/explanation" element={<Explanation />} />
      <Route path="/verifier" element={<VerifierView />} />
    </Routes>
  );
}

export default App;
